<template>
  <ModalDialog
    ref="dialog"
    :title="dialogTitle"
    icon="fa-search"
    sizeClass="modal-xl"
    :scrollable="false"
    :showSubmit="false"
  >
    <div>
      <Spinner v-if="loading" />
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>

      <div v-if="!loading && productionPanelData">
        <h2 v-if="!hasPreviewDisplayData" class="text-center text-muted font-italic">
          No preview data found in panel
        </h2>
        <div class="panel-orderitem-preview-container" v-if="hasPreviewDisplayData">
          <div v-html="productionPanelData.orderItem.svgDisplayData" class="panel-orderitem-preview" />
        </div>

      </div>

    </div>
  </ModalDialog>
</template>

<style>
/* Note: Style needs to be not-scoped for the dynamic SVG references */

.panel-orderitem-preview-container {
  position: relative;
  width: 100%;
  height: 50vh;
  background: #efefef;
  border: 2px solid #212121;
}
.panel-orderitem-preview {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 4px;
}
.panel-orderitem-preview > svg {
  width: 100%;
  height: 100%;
  max-height: 45vh;
  max-width: 80vw;
}
</style>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'PreviewPanelDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog
  },
  props: {
    productionPanelId: Number
    
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      productionPanelData: null,
    }
  },
  computed: {
    dialogTitle() {
      if(this.loading || !this.productionPanelData)
        return 'Panel Preview'
        
      return `Panel Preview - ${this.productionPanelData.barcode}`
    },
    hasPreviewDisplayData() {
      if(this.productionPanelData && this.productionPanelData.orderItem && this.productionPanelData.orderItem.svgDisplayData)
        return true
      return false
    }
  },
  mounted() {
  },
  methods: {
    show(params) {
      this.requestData()

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.glassProductionStationService.getProductionPanel(this.productionPanelId)
      .then(response => {
        this.productionPanelData = response.data
        this.loading = false

      })
      .catch(err => {
        this.loadingError = 'Error loading panel data'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>